// Surgical polyfill for Intl.NumberFormat.formatToParts, notation, signDisplay, numberingSystem and units options.
// This falls back to native for as many features as possible to conserve performance and bandwidth.
const global = window;
if (!global.Intl) {
    global.Intl = {};
}

const NumberFormat = global.Intl.NumberFormat;
const resolvedOptions = NumberFormat ? new NumberFormat().resolvedOptions() : {};
const haveFormatToParts = NumberFormat ? !!NumberFormat.prototype.formatToParts : false;
const haveNotation = 'notation' in resolvedOptions;
const haveSignDisplay = 'signDisplay' in resolvedOptions;
let haveUnit;
try {
    haveUnit = 'unit' in (NumberFormat ? new NumberFormat({ style: 'unit', unit: 'byte' }).resolvedOptions() : {});
} catch(e) { }


if (!haveFormatToParts || !haveNotation || !haveSignDisplay || !haveUnit) {
    const pad = Array(21).join(0);
    const enUS = 'en-US';
    const seps = {};
    seps[enUS] = [',','.'];

    global.Intl.NumberFormat = function(locales, options = {}) {
        let style = options.style;
        if (style === void 0) {
            style = 'decimal';
        }

        let useGrouping = options.useGrouping;
        if (useGrouping == null) {
            useGrouping = true;
        }

        let minimumIntegerDigits = options.minimumIntegerDigits;
        if (minimumIntegerDigits === void 0) {
            minimumIntegerDigits = 1;
        }
        minimumIntegerDigits |= 0;

        let minimumFractionDigits = options.minimumFractionDigits;
        if (minimumFractionDigits !== void 0) {
            if (!(minimumFractionDigits >= 0 && minimumFractionDigits <= 20)) {
                throw new RangeError('minimumFractionDigits value is out of range');
            }
        }
        minimumFractionDigits |= 0;

        let maximumFractionDigits = options.maximumFractionDigits;
        if (maximumFractionDigits === void 0) {
            maximumFractionDigits = Math.max(minimumFractionDigits, 3);
        } else if (!(maximumFractionDigits >= minimumFractionDigits && maximumFractionDigits <= 20)) {
            throw new RangeError('maximumFractionDigits value is out of range');
        }
        maximumFractionDigits |= 0;

        let minimumSignificantDigits = options.minimumSignificantDigits;
        if (minimumSignificantDigits !== void 0) {
            if (!(minimumSignificantDigits >= 1 && minimumSignificantDigits <= 21)) {
                throw new RangeError('minimumSignificantDigits value is out of range');
            }
        }
        minimumSignificantDigits |= 0;

        let maximumSignificantDigits = options.maximumSignificantDigits;
        if (maximumSignificantDigits !== void 0) {
            if (!(maximumSignificantDigits >= minimumSignificantDigits && maximumSignificantDigits <= 21)) {
                throw new RangeError('maximumSignificantDigits value is out of range');
            }
        }
        maximumSignificantDigits |= 0;

        let unit;
        if (!haveUnit && options.style == 'unit') {
            style = 'decimal';
            unit = options.unit;
            options = { ...options, unit: void 0, style };
        }

        let notation;
        if (!haveNotation && options.notation) {
            notation = options.notation;
            options = { ...options, notation: void 0 };
        }

        let format;
        let formatToParts;

        let native = NumberFormat ? new NumberFormat(locales, options) : null;
        let resolvedOptions = native ? native.resolvedOptions() : {
            locale: enUS,
            numberingSystem: 'latn',
            style,
            minimumIntegerDigits,
            minimumFractionDigits,
            maximumFractionDigits,
            useGrouping
        };
        let locale = resolvedOptions.locale;
        let lang = locale.slice(0,2);

        if (options.numberingSystem == 'latn' && resolvedOptions.numberingSystem != 'latn') {
            // Safari refuses to output Latin digits for any Arabic language
            // Hebrew includes a Left to Right Mark literal so it is a better fallback than English
            if (options.notation) {
                notation = options.notation;
                options = { ...options, notation: void 0 };
            }
            if (options.style == 'unit') {
                style = 'decimal';
                unit = options.unit;
                options = { ...options, unit: void 0, style };
            }
            native = new NumberFormat('he', options);
            locale = 'he';
            resolvedOptions.numberingSystem = 'latn';
        }
        if (native) {
            format = native.format.bind(native);
        }

        if (!haveFormatToParts) {
            let sep = seps[locale];
            if (sep === void 0) {
                const nfmt = new NumberFormat(locale, { numberingSystem: 'latn' });
                sep = seps[locale] = [
                    (nfmt.format(1e3).match(/\.|\s/) || [','])[0],
                    (nfmt.format(.1).includes(',')) ? ',' : '.'
                ];
            }
            formatToParts = new Function('d', 'return ' +
                'isNaN(d)?[{type:"nan",value:"NaN"}]:' +
                '!isFinite(d)?[{type:"infinity",value:"∞"}]:' +
                '(""+(+d))' +

                // Remove exponent
                '.replace(/(-?)(\\d*)\\.?(\\d+)e([+-]\\d+)/,function(a,b,c,d,e){return e<0?b+"0."+Array(1-e-c.length).join(0)+c+d:b+c+d+Array(e-d.length+1).join(0)})' +

                // Multiply by 100 if percent style
                (style == 'percent'
                    ? '.replace(/(\\.|$)(\\d{0,2})/,function(a,b,c){return((c+"00").slice(0,2)+b)}).replace(/^(-?)0+(?=.)/,"$1")'
                    : '') +

                (minimumSignificantDigits || maximumSignificantDigits
                    // Truncate decimal places for maximumSignificantDigits
                    ? maximumSignificantDigits
                        ? '.replace(/.*[1-9](?:\\.?\\d){' + (maximumSignificantDigits-1) + ',}/,function(a){return(+a).toPrecision(' + maximumSignificantDigits + ')})'
                        : ''

                    // Truncate decimal places for maximumFractionDigits
                    : '.replace(/.*\\.\\d{' + (maximumFractionDigits+1) + ',}$/,function(a){return(+a).toFixed(' + maximumFractionDigits + ')})') +

                (minimumSignificantDigits || maximumSignificantDigits
                    // Pad or truncate zeros for minimumSignificantDigits
                    ? minimumSignificantDigits
                        ? '.replace(/^[-0.]*([1-9](?:\\.?\\d){0,' + (minimumSignificantDigits-1) + '}$|$)/,function(a,b){return(+a).toPrecision(' + minimumSignificantDigits + ')})'
                        : ''

                    // Pad or truncate zeros for minimumFractionDigits
                    : '.replace(/\\.(\\d*?)0*$' + (minimumFractionDigits ? '|$' : '') + '$/,function(a,b){return ' +
                        (minimumFractionDigits
                            ? '"."+b+"' + pad.slice(0,minimumFractionDigits) + '".slice(b?b.length:0)'
                            : 'b?"."+b:""') +
                        '})') +

                // Split into parts
                '.match(/[-.]|\\d+/g)' +
                '.reduce(function(a,v,i){return a.concat(isNaN(v)?{type:{"-":"minusSign",".":"decimal"}[v],value:v=="."?"' + sep[1] + '":v}:i>1?{type:"fraction",value:v}:v.match(' +

                // Add thousands grouping
                (useGrouping
                    ? '/\\d{1,3}(?=(\\d{3})*$)/g'
                    : '/.+/') +
                ').reduce(function(a,v,i,z){return a.concat({type:"integer",value:v},i<z.length-1?{type:"group",value:"' + sep[0] + '"}:[])},[]))},[])' +

                // Add percent sign if percent style
                (style == 'percent'
                    ? '.concat([' + (lang == 'ar' || lang == 'he' ? '{type:"literal",value:"\u200e"},' : '') + '{type:"percentSign",value:"%"}])'
                    : ''));
        } else {
            formatToParts = native.formatToParts.bind(native);
        }

        if (notation) {
            resolvedOptions.notation = notation || 'standard';
            if (notation == 'compact') {
                const abbreviations = {
                    en: [[1e3,,'K'],[1e3,,'M'],[1e3,,'B'],[1e3,,'T']],
                    de: [[1e6,1,'Mio.'],[1e3,1,'Mrd.'],[1e3,1,'Bio.']],
                    es: [[1e3,1,'mil'],[1e3,1,'M'],[1e6,,'B']],
                    fr: [[1e3,1,'k'],[1e3,1,'M'],[1e3,1,'Md'],[1e3,1,'Bn']],
                    it: [[1e6,1,'Mln'],[1e3,1,'Mrd'],[1e3,1,'Bln']],
                    ru: [[1e3,1,'тыс.'],[1e3,1,'млн'],[1e3,1,'млрд'],[1e3,1,'трлн']],
                    ja: [[1e4,,'万'],[1e4,,'亿'],[1e4,,'万亿']],
                    zh: [[1e4,,'万'],[1e4,,'亿'],[1e4,,'万亿']],
                    ar: [[1e3,1,'ألف'],[1e3,1,'مليون'],[1e3,1,'مليار'],[1e3,1,'ترليون']]
                };
                const compactRounding =
                    options.minimumFractionDigits === void 0 &&
                    options.maximumFractionDigits === void 0 &&
                    options.minimumSignificantDigits === void 0 &&
                    options.maximumSignificantDigits === void 0;
                const nformatToParts = formatToParts;
                const nabbreviations = abbreviations[lang] || abbreviations.en;
                formatToParts = number => {
                    let magnitude = 0;
                    let epsilon = .5 / 10 ** (minimumFractionDigits | 0);
                    while (nabbreviations[magnitude] && Math.abs(number) >= nabbreviations[magnitude][0] - epsilon) {
                        number /= nabbreviations[magnitude++][0];
                    }
                    return nformatToParts(compactRounding ? number.toFixed(number < 10) : number)
                        .concat(magnitude ? (nabbreviations[magnitude-1][1] ? [{
                            type: 'literal',
                            value: '\xa0'
                        }] : []).concat({
                            type: 'compact',
                            value: nabbreviations[magnitude-1][2]
                        }) : []);
                }
                format = null;
            }
        }

        if (!haveSignDisplay) {
            const signDisplay = options.signDisplay;
            resolvedOptions.signDisplay = signDisplay || 'auto';
            if (signDisplay == 'always' || signDisplay == 'exceptZero') {
                const nformatToParts = formatToParts;
                const exceptZero = signDisplay == 'exceptZero';
                const part = (lang == 'ar' || lang == 'he' ? [{
                    type: 'literal',
                    value: '\u200e'
                }] : []).concat([{
                    type: 'plusSign',
                    value: '+'
                }]);
                formatToParts = number => {
                    const result = nformatToParts(number);
                    return (number < 0 || (exceptZero && !number))
                        ? result
                        : part.concat(result);
                }
                format = null;
            }
        }

        if (unit) {
            const nformatToParts = formatToParts;
            const units = ['byte','kilobyte','megabyte','gigabyte','terabyte','petabyte'];
            const evals = ['byte','kB','MB','GB','TB','PB'];
            const lvals = {
                de: ['Bytes'],
                es: ['B'],
                fr: ['o','ko','Mo','Go','To','Po'],
                ru: ['Б','кБ','МБ','ГБ','ТБ','ПБ'],
                zh: ['字节','千字','兆字节','吉字节','太字节'],
                he: ['בייט'],
                ar: ['بايت','كيلوبايت','ميغابايت','غيغابايت']
            };
            const i = units.indexOf(unit);
            if (i < 0) {
                throw new RangeError('Invalid unit argument ' + unit);
            }
            resolvedOptions.style = 'unit';
            resolvedOptions.unit = unit;
            formatToParts = number => nformatToParts(number).concat([{
                type: 'literal',
                value: '\xa0'
            }, {
                type: 'unit',
                value: (lvals[lang]||{})[i] || evals[i]
            }]);
            format = null;
        }

        this.formatToParts = formatToParts;
        this.format = format || (number => formatToParts(number).map(part => part.value).join(''));
        this.resolvedOptions = () => ({ ...resolvedOptions });
    }

    Number.prototype.toLocaleString = function(locales, options) {
        return new Intl.NumberFormat(locales, options).format(this);
    }
}
